import React, { useEffect, useState } from 'react'
import CommonReactTable from '../../CommonUtils/CommonReactTable';
import * as bie from "react-bootstrap";
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { FaDownload } from 'react-icons/fa';
import { viewImage } from '../../CommonUtils/viewImage';
import { AC_YEAR_OLD } from '../../CommonUtils/contextVariables';

export default function OADMCCollegeStatusReport() {
    const acYear = sessionStorage.getItem('ac_year');

    const [showName, setShowName] = useState("")
    const [showDrillCount, setShowDrillCount] = useState();

    function GetPdf(colcode) {
        let url = config.url.API_URL + `getdegreepdf/${colcode}/${acYear}`
        CommonAxiosPost(url).then((res) => {
            if (res?.data?.Status === true) {
                viewImage(res?.data?.path)
            }
            else {
                console.log(res);
            }
        })
    }
    const Columns = [
        { Header: "Sl.No", accessor: (row, index) => index + 1, Footer: 'Total' },
        {
            Header: "University Name", accessor: "ub_name", Footer: "",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.ub_name}</div>
            ),
        },
        {
            Header: "Number of OAMDC Participating colleges (Private Un-Aided Only)", accessor: "count",
            Cell: ({ row }) => (
                <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                    onClick={() => {
                        GettUniversityWiseCourseDetails(row?.original?.ub_code, 1, "");
                        setShowName("Number of OAMDC Participating colleges (Private Un-Aided Only)")
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            GettUniversityWiseCourseDetails(row?.original?.ub_code, 1, "");
                            setShowName("Number of OAMDC Participating colleges (Private Un-Aided Only)")
                        }
                    }}  >{row?.values?.count}</div>
            ),
            Footer: "count"
        },
        {
            Header: `Application for Affiliation  ${acYear}`,
            columns: [
                {
                    Header: "Submitted", accessor: "con",
                    Cell: ({ row }) => (
                        <div
                            style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                GettUniversityWiseCourseDetails(row?.original?.ub_code, 5, "submitted");
                                setShowName(`Number of Colleges that have submitted Application for Affiliation ${acYear}`)
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 5, "submitted");
                                    setShowName(`Number of Colleges that have submitted Application for Affiliation ${acYear}`)
                                }
                            }}
                        >{row?.values?.con}</div>
                    ),
                    Footer: "con"
                },
                {
                    Header: "Not Submitted", accessor: "not_con",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                GettUniversityWiseCourseDetails(row?.original?.ub_code, 6, "");
                                setShowName(`Number of Colleges that have not submitted Application for Affilaition ${acYear}`)
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 6, "");
                                    setShowName(`Number of Colleges that have not submitted Application for Affilaition ${acYear}`)
                                }
                            }}>{row?.values?.not_con}</div>
                    ),
                    Footer: "not_con"
                },
            ],
        },
        {
            Header: `FFCA Status`,
            columns: [
                {
                    Header: "FFCA Done", accessor: "ffca",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                GettUniversityWiseCourseDetails(row?.original?.ub_code, 10, "ffca");
                                setShowName(`Number of Colleges FFCA Application for Affiliation ${acYear}`)
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 10, "ffca");
                                    setShowName(`Number of Colleges FFCA Application for Affiliation ${acYear}`)
                                }
                            }}
                        >{row?.values?.ffca}</div>
                    ),
                    Footer: "ffca"
                },
                {
                    Header: "FFCA Not Done", accessor: "ffca_not_done",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                GettUniversityWiseCourseDetails(row?.original?.ub_code, 11, "");
                                setShowName(`Number of Colleges FFCA Application Not Done for Affiliation ${acYear}`)
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 11, "");
                                    setShowName(`Number of Colleges FFCA Application Not Done for Affiliation ${acYear}`)
                                }
                            }}
                        >{row?.values?.ffca_not_done}</div>
                    ),
                    Footer: "ffca_not_done"
                },
            ],
        },
        {
            Header: "CDC dean Status",
            columns: [
                {
                    Header: "CDC Confirmed", accessor: "cdc_confirm",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                GettUniversityWiseCourseDetails(row?.original?.ub_code, 7, "");
                                setShowName("CDC dean confirmed Colleges")
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 7, "");
                                    setShowName("CDC dean confirmed Colleges")
                                }
                            }}
                        >{row?.values?.cdc_confirm}</div>
                    ),
                    Footer: "cdc_confirm"
                },
                {
                    Header: "CDC Not Confirmed", accessor: "cdc_not_confirm",
                    Cell: ({ row }) => (
                        <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                            onClick={() => {
                                GettUniversityWiseCourseDetails(row?.original?.ub_code, 12, "");
                                setShowName("CDC dean Not confirmed Colleges")
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    GettUniversityWiseCourseDetails(row?.original?.ub_code, 12, "");
                                    setShowName("CDC dean Not confirmed Colleges")
                                }
                            }}
                        >{row?.values?.cdc_not_confirm}</div>
                    ),
                    Footer: "cdc_not_confirm"
                },
            ],
        },
        {
            Header: `Total Affiliation Order Generated ${acYear}`, accessor: "affiliation_order",
            Cell: ({ row }) => (
                <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                    onClick={() => {
                        GettUniversityWiseCourseDetails(row?.original?.ub_code, 8, "");
                        setShowName(`Affiliation Generated ${acYear} Colleges`)
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            GettUniversityWiseCourseDetails(row?.original?.ub_code, 8, "");
                            setShowName(`Affiliation Generated ${acYear} Colleges`)
                        }
                    }}  >{row?.values?.affiliation_order}</div>
            ),
            Footer: "affiliation_order"
        },

    ]

    const totalcollegeColumns = [
        { Header: "Sl.No", accessor: (row, index) => index + 1 },
        {
            Header: "University Name", accessor: "ub_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.ub_name}</div>
            ),
        },
        {
            Header: "College Code", accessor: "college_code",
        },

        {
            Header: "College Name", accessor: "inst_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.inst_name}</div>
            ),
        },
        {
            Header: "College Type", accessor: "course_group_desc",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.course_group_desc}</div>
            ),
        },
        {
            Header: "College building Accommodation Submitted by University", accessor: "coalesce",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.coalesce}</div>
            ),
        },
        {
            Header: `Type of Affiliation ${AC_YEAR_OLD}`, accessor: "registrar_remarks",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.registrar_remarks}</div>
            ),
        },

        ...(showName === `Number of Colleges that have submitted Application for Affiliation ${acYear}`) ? [

            {
                Header: `College report`, accessor: "",
                Cell: ({ row }) => (
                    <div style={{ cursor: "pointer", textAlign: 'right', color: "blue" }}
                        onClick={() => {
                            GetPdf(row?.original?.college_code);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                GetPdf(row?.original?.college_code);
                            }
                        }}  > <FaDownload size={20} /></div>
                ),
            },
        ] : [],


        // ffca done
        ...(showName === `Number of Colleges FFCA Application for Affiliation ${acYear}`) ? [
            {
                Header: "FFCA Report",
                accessor: '',
                Cell: ({ row }) => {
                    return (
                        <button type="button" className="btn text-center"
                            onClick={() => {
                                GetFfcaSubmissionPdf(row?.original?.college_code)
                            }}>
                            <FaDownload size={20} />
                        </button>
                    )
                }
            },

            {
                Header: "Mobile App Photos", accessor: "",
                Cell: ({ row }) => {
                    return (<>
                        {/* {row?.original?.final_pdf_path === "-" ? ("-") : ( */}
                        <button type="button" className="btn text-center"
                        // onClick={() => {
                        //     viewImage(row?.original?.final_pdf_path)
                        // }}
                        >
                            <FaDownload size={20} />
                        </button>
                        {/* )} */}
                    </>
                    )
                }
            },
        ] : [],

        // Affiliation Generated
        ...(showName === `Affiliation Generated ${acYear} Colleges`) ? [
            {
                Header: "Generated Affiliation Order", accessor: "",
                Cell: ({ row }) => {
                    return (<>
                        {row?.original?.final_pdf_path === "-" ? ("-") : (
                            <button type="button" className="btn text-center"
                                onClick={() => {
                                    viewImage(row?.original?.final_pdf_path)
                                }}>
                                <FaDownload size={20} />
                            </button>)}</>
                    )
                }
            },
        ] : [],
    ]
    const [showAfflCourseConversionOrderData, setAfflCourseConversionOrderData] = useState([]);
    const [showUniversityWiseCourseData, setUniversityWiseCourseData] = useState([]);
    function GetAfflCourseConversionOrderDetails() {
        let url = config.url.API_URL + `getafflcourseconorder`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setAfflCourseConversionOrderData(res?.data?.data)
                setShowDrillCount(0)
            }
            else {
                setAfflCourseConversionOrderData([])
            }
        })
    }

    function GettUniversityWiseCourseDetails(ubcode, level, colname) {
        let url = config.url.API_URL + "getafflcourseconorderdrill/" + ubcode + "/" + level;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setUniversityWiseCourseData(res?.data?.data);
                setShowDrillCount(1)
            }
            else {
                setUniversityWiseCourseData([])
            }
        })
    }
    function GetFfcaSubmissionPdf(collcode) {
        let url = config.url.API_URL + `getFfcaPdf/` + collcode + "/" + acYear;
        CommonAxiosPost(url).then((res) => {
            if (res?.data?.Status === true) {
                viewImage(res?.data?.path)
            } else {
                console.log("No Data Found")

            }
        })
    }
    useEffect(() => { GetAfflCourseConversionOrderDetails() }, [])
    function isBackFunction() {
        setShowDrillCount(showDrillCount - 1)
    }
    return (
        <div>
            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100">
                    {showDrillCount === 0 && (
                        <>
                            <div className="inner-herbpage-service-title-sub pt-0"  >
                                <h1>{`OAMDC Colleges Affiliation Status Report - ${acYear} `}</h1>
                            </div>
                            <bie.Row className="my-3 px-3">
                                <div className="table-responsive">
                                    <CommonReactTable data={showAfflCourseConversionOrderData} columns={Columns}
                                        filename={`OAMDC Colleges Affiliation Status Report -  ${acYear} `}
                                        headerName={`OAMDC Colleges Affiliation Status Report - ${acYear} `} showFooter={"true"} />
                                </div>
                            </bie.Row>
                        </>
                    )
                    }
                    {
                        showDrillCount === 1 && (
                            <bie.Row className="my-3 px-3">
                                <div className="inner-herbpage-service-title-sub pt-0"> <h1>{showName}-{ }</h1> </div>
                                <div className="table-responsive">
                                    <CommonReactTable data={showUniversityWiseCourseData} columns={totalcollegeColumns} filename={showName}
                                        headerName={showName} isBack={true} isBackFunction={isBackFunction} />
                                </div>
                            </bie.Row>
                        )
                    }
                </bie.Container >
            </bie.Container >
        </div >
    )
}
